export default __webpack_public_path__ + "static/googleSheetLogo-729907bc38afbadfbb7e63f12a50d360.svg";